import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

export const getExtract = params => {
  return axios.request({
    url: "/extract/extract",
    method: "get",
    params
  });
};

export const info = params => {
  return axios.request({
    url: "/extract/email_content",
    method: "get",
    params
  });
};

export const read = params => {
  return axios.request({
    url: "/Extract/build_task",
    method: "get",
    params
  });

}

export const getPackages = id => {
  return axios.request({
    url: `/extract/extractHandle/getPackages/${id}`,
    method: "get"
  });
};

export const getPacking = id => {
  return axios.request({
    url: `/extract/extractHandle/getPacking/${id}`,
    method: "get"
  });
};

export const getDetails = id => {
  return axios.request({
    url: `/extract/extract/${id}`,
    method: "get"
  });
};

// 更新
export const update = data => {
  return axios.request({
    url: `/extract/extract/${data.id}`,
    method: "put",
    data
  });
};
// 删除
export const del = id => {
  return axios.request({
    url: `/extract/extract/${id}`,
    method: "DELETE"
  });
};

// 更新
export const postFlightTracker = (id, data) => {
  return axios.request({
    url: `/extract/extractHandle/flightTracker/${id}`,
    method: "put",
    data
  });
};

export const getExtractAnalyze = id => {
  return axios.request({
    url: `/extract/extractHandle/getExtractAnalyze/${id}`,
    method: "get"
  });
};

export const getExportExcel = id => {
  return axios.request({
    url: `/extract/extractHandle/exportExtractExcel/${id}`,
    method: "get"
  });
};

export const exportBatchExtract = data => {
  return axios.request({
    url: `/extract/extractHandle/exportBatchExtract`,
    method: "post",
    data
  });
};

export const exportThatDay = data => {
  return axios.request({
    url: `/extract/extractHandle/exportThatDay`,
    method: "post",
    data
  });
};

// 导出航司信息
export const exportAirline = data => {
  return axios.request({
    url: `/extract/extractHandle/exportMawb`,
    method: "post",
    data
  });
};

export const share = data => {
  return axios.request({
    url: `/extract/share`,
    method: "post",
    data
  });
};

export const thirdParty = mawb => {
  return axios.request({
    url: `/extract/extract/thirdParty`,
    method: "get",
    params: {
      mawb
    }
  });
};

export const exportOrder = data => {
  return axios.request({
    url: `/extract/extract/exportOrder`,
    method: "post",
    data
  });
};

export const bayan = params => {
  return axios.request({
    url: `/extract/extract/bayan/${params.id}`,
    method: "get",
    params
  });
};


export const upload = (data,id) => {
  return axios.request({
    url: `/extract/extract/upload/${id}`,
    data,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    }
  });
};
